/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteResponse
 */
export interface SiteResponse {
    /**
     * 
     * @type {number}
     * @memberof SiteResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteResponse
     */
    customerId?: number;
}

/**
 * Check if a given object implements the SiteResponse interface.
 */
export function instanceOfSiteResponse(value: object): value is SiteResponse {
    return true;
}

export function SiteResponseFromJSON(json: any): SiteResponse {
    return SiteResponseFromJSONTyped(json, false);
}

export function SiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
    };
}

export function SiteResponseToJSON(json: any): SiteResponse {
    return SiteResponseToJSONTyped(json, false);
}

export function SiteResponseToJSONTyped(value?: SiteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'customerId': value['customerId'],
    };
}

